import React from "react";
import { Reveal, Overline } from "./Motion";
import { FEATURES } from "@/data/cafe";
import { Coffee, Leaf, Armchair, Wifi, Zap, HeartHandshake, Croissant, Users } from "lucide-react";

const ICONS = { Coffee, Leaf, Armchair, Wifi, Zap, HeartHandshake, Croissant, Users };

export default function Features() {
  return (
    <section className="bg-[#F5F2EB] py-24 md:py-32" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <Overline>Why Choose Us</Overline>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1A1514] mt-4 font-medium">
            Small details, <span className="italic text-[#1C7C54]">big difference</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#1A1514]/10 border border-[#1A1514]/10 mt-14 rounded-sm overflow-hidden">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon] || Coffee;
            return (
              <Reveal key={f.title} delay={(i % 4) * 0.06}>
                <div className="bg-[#F5F2EB] p-7 md:p-9 h-full group hover:bg-[#E5DFD3] transition-colors duration-300" data-testid={`feature-${i}`}>
                  <Icon className="h-7 w-7 text-[#1C7C54] group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                  <h3 className="font-display text-xl text-[#1A1514] mt-6 leading-tight">{f.title}</h3>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
